import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keypadHeaderStyles = makeStyles((theme: any) => ({
  labelContainer: {
    paddingLeft: '1.59vw',
    flexWrap: 'nowrap',
  },
  defaultLabel: {
    color: themeColor.defaultTextColor,
    paddingTop: '1.56vh',
    '@media (max-height: 576px)': {
      fontSize: rem(0.75),
    },
  },
  singleLineLabel: {
    paddingTop: '3.56vh',
    paddingBottom: '1.56vh',
  },
  closeIconContainer: {
    marginLeft: 'auto',
  },
  closeIcon: {
    color: 'inherit',
    height: '4.565vh',
    width: '4.565vh',
  },
  keypadButton: {
    background: theme?.configColors?.primaryColor || theme.primaryMain,
    color: theme?.configColors?.primaryText || theme.white,
    minWidth: '7.29vh',
    marginLeft: '0.5vw',
    width: '7.29vh',
    height: '7.29vh',
    borderRadius: '2px',
    boxShadow: `0 1px 3px 0 ${themeColor.almostwhite}`,
    '&:hover': {
      boxShadow: 'none',
      color: theme?.configColors?.primaryText || theme.white,
      background: theme?.configColors?.primaryColor || theme.primaryMain,
      opacity: 0.9,
    },
    '@media (max-width: 1024px)': {
      minWidth: '5.29vh',
      width: '5.29vh',
      height: '5.29vh',
    },
  },
}));
